import React from 'react';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import OrderConfirm from './OrderConfirm';
import OrderEdit from './OrderEdit';
import { FieldArray } from 'react-final-form-arrays';
import i18n from 'i18n';
import BlockHeader from 'components/common/BlockHeader';
import { cloneDeep } from 'lodash';
import Layer from './Layer';

const orderTemplate = {
  receiver: {
    receiverName: '',
    receiverNameKana: '',
    receiverPostcode: '',
    receiverPrefecture: '',
    receiverCity: '',
    receiverBuilding: '',
    receiverCompany: '',
    receiverTelephone: ''
  },
  shipper: {
    shipperName: '',
    shipperNameKana: '',
    shipperPostcode: '',
    shipperPrefecture: '',
    shipperCity: '',
    shipperBuilding: '',
    shipperCompany: '',
    shipperTelephone: ''
  },
  referringOrderInfo: {
    checked: false,
    targetIndex: 0
  }
};

const validateOrders = inEdit => {
  return inEdit.some(state => state);
};

const invalidOrder = order => {
  return (
    order.receiver === orderTemplate.receiver ||
    order.shipper === orderTemplate.shipper
  );
};

const createReferredOrderOptions = orders => {
  const options = [];
  orders.forEach((el, index) => {
    if (!el.referringOrderInfo.checked) {
      options.push({
        label: `${i18n.t('orderAggregators:common:order.order')}${index + 1}`,
        value: index
      });
    }
  });
  return options;
};

const updateOrder = (orders, update, index, refIndex) => {
  const { receiver, shipper, referringOrderInfo } =
    refIndex !== null ? cloneDeep(orders[refIndex]) : orderTemplate;

  if (referringOrderInfo.checked) {
    update('orders', index, {
      ...orders[index],
      receiver,
      shipper,
      referringOrderInfo
    });
  } else {
    update('orders', index, {
      ...orders[index],
      receiver,
      shipper
    });
  }
};

const updateReferringOrders = (orders, update, refIndex) => {
  orders.forEach((elm, index) => {
    if (
      elm.referringOrderInfo.checked &&
      +elm.referringOrderInfo.targetIndex === refIndex
    ) {
      updateOrder(orders, update, index, refIndex);
    }
  });
};

const Orders = ({
  className,
  datepickerMin,
  datepickerMax,
  fetchAddress,
  duration,
  form,
  onClickEdit,
  onClickComplete,
  onClickCancel,
  inEdit
}) => (
  <div className={className}>
    {inEdit.some(v => !!v) ? (
      <Layer
        children={
          <BlockHeader>
            {i18n.t('orderAggregators:confirmation:ordersInfo')}
          </BlockHeader>
        }
      />
    ) : (
      <BlockHeader>
        {i18n.t('orderAggregators:confirmation:ordersInfo')}
      </BlockHeader>
    )}

    <div className="orders">
      <FieldArray
        name="orders"
        validate={() => validateOrders(inEdit)}
        render={({ fields }) => (
          <React.Fragment>
            {fields.map((name, index) => {
              if (inEdit[index]) {
                return (
                  <OrderEdit
                    key={index}
                    index={index + 1}
                    fieldName={name}
                    datepickerMin={datepickerMin}
                    datepickerMax={datepickerMax}
                    duration={duration}
                    fetchAddress={fetchAddress}
                    onClickComplete={onClickComplete}
                    onClickCancel={onClickCancel}
                    referredOrderOptions={createReferredOrderOptions(
                      form.getState().values.orders
                    )}
                    updateOrder={refIndex =>
                      updateOrder(
                        form.getState().values.orders,
                        form.mutators.update,
                        index,
                        refIndex
                      )
                    }
                    updateReferringOrders={refIndex =>
                      updateReferringOrders(
                        form.getState().values.orders,
                        form.mutators.update,
                        refIndex
                      )
                    }
                    orders={form.getState().values.orders}
                    invalidOrder={invalidOrder}
                    {...form}
                  />
                );
              }

              return inEdit.some(v => !!v) ? (
                <Layer
                  key={index}
                  children={
                    <OrderConfirm
                      index={index + 1}
                      fieldName={name}
                      onClickEdit={onClickEdit}
                      {...form}
                    />
                  }
                />
              ) : (
                <OrderConfirm
                  key={index}
                  index={index + 1}
                  fieldName={name}
                  onClickEdit={onClickEdit}
                  {...form}
                />
              );
            })}
          </React.Fragment>
        )}
      />
    </div>
  </div>
);

const pcStyle = CustomMedia.greaterThan('umedium')`
  .orders {
    max-width: 762px;
    margin-bottom: 72px;
  }

  ${OrderConfirm},
  ${OrderEdit} {
    padding: 0 16px;

    table {
      margin-bottom: 16px;
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
`;

export default applyStyles(Orders)(pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Confirmation/components/Orders.js